// extracted by mini-css-extract-plugin
export default {"tooltip":"HoverTooltip_tooltip__Q20FU","tooltiptext":"HoverTooltip_tooltiptext__GXv2M"};